export default __webpack_public_path__ + "static/media/heart.cd60304f.svg";